import $ from "jquery";
import { activityReportFilters } from "./activityReportFilters";
import { dataaccess } from "../dataaccess/dataContext";
import { fileDownloader } from "../framework/fileDownloader";

let activityTable;
const tableColumns = ["Dates", "User", "Role", "ActionType", "Service", "PreviousValue", "CurrentValue"];
let currentPage = 0;
const pageSize = 20;
let hasNextPage;
let dataSet = [];
let sort = {};

function init() {
    $("#btnApplyFilters").click(applyFilters);
    $("#btnDownloadExcel").click(downloadReport);
    $("#next").click(goNextPage);
    $("#previous").click(goPreviousPage);
    $(".sorting, .sorting_asc, .sorting_desc").click(applySort);
    getData().then(function(data) {
        buildDataSet(data);
        buildTable();
    });
}

function downloadReport() {
    const filters = activityReportFilters.getFilters();
    filters.desc = sort.desc;
    filters.sortColumn = sort.column || "";

    fileDownloader.downloadFile(
        { url: "/ActivityReport/GetActivityReportExcel", data: filters, method: "POST" });
}

function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    const filters = activityReportFilters.getFilters();
    applyFilters(filters);
}
function goPreviousPage() {
    if (currentPage === 0) return;
    currentPage--;
    const filters = activityReportFilters.getFilters();
    applyFilters(filters);
}

function buildDataSet(data) {
    dataSet = [];
    if (!data || !data.length) { return; }
    for (let i = 0; i < data.length; i++) {
        dataSet.push([data[i].date, data[i].users, data[i].roles, data[i].actionType, data[i].service, data[i].recordId, data[i].field, data[i].previousValue, data[i].currentValue]);
    }
    hasNextPage = data.length > pageSize;
    setNextPrevButtonEnabled();
}

function buildTable() {
    activityTable = $("#activityTable").DataTable({
        "serverSide": false, // for process server side
        "filter": false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        "data": dataSet,
        "bLengthChange": false,
        "bPaginate": false,
        "PageLength": 20,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    "name": "Date"
                },
                {
                    "targets": 1,
                    "name": "User"
                },
                {
                    "targets": 2,
                    "name": "Role(s)"
                },
                {
                    "targets": 3,
                    "name": "ActionType"
                },
                {
                    "targets": 4,
                    "name": "Service"
                },
                {
                    "targets": 5,
                    "name": "RecordId"
                },
                {
                    "targets": 6,
                    "name": "Field"
                },
                {
                    "targets": 7,
                    "name": "PreviousValue"
                },
                {
                    "targets": 8,
                    "name": "CurrentValue"
                }
            ]
    });
}

function applyFilters() {
    $("#activityreportfilterbuttonsdiv .btn").prop("disabled", true);
    getData().then(function(data) {
        buildDataSet(data);
        activityTable.clear();
        activityTable.rows.add(dataSet).draw();
        setNextPrevButtonEnabled();
        $("#activityreportfilterbuttonsdiv .btn").prop("disabled", false);
    });
}

function applySort(e) {
    const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
    $(".sorting, .sorting_asc, .sorting_desc").removeClass()
        .addClass("sorting");

    if (asc) {
        $(this).removeClass("sorting").removeClass("sorting_desc").addClass("sorting_asc");
    } else {
        $(this).removeClass("sorting").removeClass("sorting_asc").addClass("sorting_desc");
    }
    $(".sorting, .sorting_asc, .sorting_desc").not($(this)).removeClass(".sorting_asc").removeClass(".sorting_desc")
        .addClass("sorting");
    sort = {
        column: tableColumns[activityTable.column(this).index()],
        desc: $(this).hasClass("sorting_desc")
    };
    applyFilters();
}

function getData() {
    const filters = activityReportFilters.getFilters();
    filters.desc = sort.desc;
    filters.sortColumn = sort.column || "";
    return dataaccess.post({ url: "/ActivityReport/getActivityReport/" + currentPage, data: filters });
}

function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 0) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}

export const activityReport = {
    init: init
};